export const paths = {
    trocas : "/Trocas",
    ordensDeManutencao : "/OrdensDeManutencao"
}

export const version = "1.2.5"